const Currency = (number, Component) => {
    // Handle undefined, null, or the string "undefined"
    if (number === undefined || number === null || number === 'undefined' || number === '') {
        return '';
    }
    const n = number + "";
    const s = n.split(".");
    const hasCents = n.includes(".") && s[1] != ".00";
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: hasCents ? 2 : 0,
    });
    if (isNaN(number)) {
        return n.includes("$") ? number : "$" + number;
    }
    const dollarsCents = formatter.format(number);
    const [D, C] = dollarsCents.split(".");
    if (Component) {
        return <Component dollars={D} cents={C} />;
    } else {
        return hasCents ? dollarsCents : D;
    }
};
export default Currency